import { Shot } from '@/features/shotlist/store/useShotListStore'
import { db, ShotListEntity } from '@/shared/lib/db'
import { BaseLocalRepository } from '@/shared/services/repository/BaseRepository'

class ShotListRepository extends BaseLocalRepository<ShotListEntity> {
    constructor() {
        super(db.shotlists, 'shotlists')
    }

    async getBySceneId(projectId: string, sceneId: string): Promise<ShotListEntity | undefined> {
        return this.table.where('[projectId+sceneId]').equals([projectId, sceneId]).first()
    }

    async saveShots(projectId: string, sceneId: string, shots: Shot[]) {
        const existing = await this.getBySceneId(projectId, sceneId)
        
        const entity: ShotListEntity = {
            id: existing?.id ?? crypto.randomUUID(),
            projectId,
            sceneId,
            shots,
            created_at: existing?.created_at ?? new Date(),
            updated_at: new Date()
        }
        
        await this.save(entity)
    }
}

export const shotListRepository = new ShotListRepository()
